import React from "react";

const IconVideo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg data-name="Calque 1" viewBox="0 0 120 120" width="1em" height="1em" {...props}>
      <path
        d="M100.08,17.92H18.27a9.15,9.15,0,0,0-9.1,9.19V82.73A9.17,9.17,0,0,0,18.27,92H41v9.26H77.36V92h22.72a9.16,9.16,0,0,0,9-9.26l0-55.56a9.16,9.16,0,0,0-9.08-9.25Zm0,64.81H18.27V27.17h81.81ZM77.36,55,45.54,73.47v-37Z"
        fill="curentColor"
      />
    </svg>
  );
};

export default IconVideo;
